module.exports = "/_next/static/images/dbb9431ed6375cb8cc02d919230d70de-pay-yourself-lg@2x.jpg";